module.exports = __webpack_public_path__ + "static/media/15.d725d962.mp3";